import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmpresaService } from '../services/empresa.service';
import { Empresa } from '../model/empresa';
import { MotorService } from '../services/motor.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-search-body',
  templateUrl: './search-body.component.html',
  styleUrls: ['./search-body.component.css']
})
export class SearchBodyComponent implements OnInit {

  constructor(private spinnerService: NgxSpinnerService) {
  }

  ngOnInit() {
  }
 
  spinner(): void {
    this.spinnerService.show();
    setTimeout(() =>{
      this.spinnerService.hide();
    }, 2000);
  }
}
